import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetActivitiesInProgressCountGroupedByOrganizationUseCaseInterface } from 'domain/usecases';

export class RemoteGetActivitiesInProgressCountGroupedByOrganization
  implements GetActivitiesInProgressCountGroupedByOrganizationUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(): Promise<GetActivitiesInProgressCountGroupedByOrganizationUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
